var allowedTypes = ['wide', 'full-width'];
var breakout = {
    spanning: false,
    inclusive: false,
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function (dom) {
                var mode = dom.getAttribute('data-mode');
                return {
                    mode: allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                };
            },
        },
    ],
    attrs: {
        mode: { default: 'wide' },
    },
    toDOM: function (mark) {
        return [
            'div',
            { class: 'fabric-editor-breakout-mark', 'data-mode': mark.attrs.mode },
            0,
        ];
    },
};

export { breakout };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/breakout.js